import * as types from './types'

export default {
  [types.PARAMS_TO_SEND](state) {
    return {
      // pagination
      limit: state.pagination.itemsPerPage,
      offset: (state.pagination.page - 1) * state.pagination.itemsPerPage,
      // filters
      account_id: state.filters.accountId,
      investor_id: state.filters.investorId,
      currency: state.filters.currency,
      active: state.filters.active,
      product: state.filters.product
    }
  },
  [types.STRATEGY_ETR_LIST](state) {
    return state.strategiesETR.data.map((str) => {
      return {
        strategyID: str.id,
        strategyName: str.name,
        active: str.active,
        currency: str.currency
      }
    })
  },
  [types.PARTNERS](state) {
    return state.partners.map((partner) => ({
      text: partner.name,
      value: partner.id
    }))
  },
  [types.SELECTED_PARTNERS]: function (state) {
    return []
  }
}
